import { checklistApis } from '@apis/checklistApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchChecklist } from '@models/Checklist';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchChecklist = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchChecklist) => {
      const response = await checklistApis.patch('/company/checklist/', { body });
      if (response[400]) {
        throw new FormError('PatchChecklist', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/company/checklist/']);
      },
    },
  );
};
